import React from 'react';
import ContentWrapper from '../Layout/ContentWrapper';
import {Button, InputGroup, DropdownItem, DropdownToggle, DropdownMenu, UncontrolledButtonDropdown} from 'reactstrap';
import {Link} from 'react-router-dom';
import {getInvLists, getLedger} from './InventoryFunctions.js';
import {getStaff} from '../Staff/StaffFunctions.js';
import Swal from 'sweetalert2'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment';
import 'moment-timezone';

moment.tz.setDefault("America/Toronto");

const DOC_NAMES = {
    PO: 'Purchase Order', IR: 'Item Receipt', TO: 'Transfer Order',
    TR: 'Inventory Transfer', AJ: 'Inventory Adjustment',
    WO: 'Work Order', AB: 'Assembly Build'
};
const LEGACY_CODES = {1: "New Product", 4: "Reconciliation", 2: "Damaged", 3: "Sample", 0: "Transfer"};

const fmt = (v) => {
    const n = parseFloat(v) || 0;
    return (Math.round(n * 100) / 100).toLocaleString('en-CA', {maximumFractionDigits: 2});
};

class InventoryTransactions extends React.Component {
    constructor(props) {
        super(props);

        this.updateDates = this.updateDates.bind(this);

        this.state = {
            transactions: [],
            loading: true,
            lists: {items: [], locations: []},
            staff: [],
            // filters
            item_id: null,
            location_id: null,
            doc_type: null,
            staff_id: null,
            startDate: moment().subtract(29, 'days'),
            endDate: moment().endOf('day'),
            // filter names
            item_name: "All",
            location_name: "All",
            doc_type_name: "All",
            staff_name: "All",
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment().endOf('day')],
                'Last 30 Days': [moment().subtract(29, 'days'), moment().endOf('day')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                'All Time': [moment("01 Jan 2025"), moment().endOf('day')]
            }
        };
    }

    componentDidMount() {
        document.title = "Inventory Transactions | Jug Beverage Company";
        var self = this;
        getInvLists(function (lists) {
            getStaff(function (staff) {
                self.setState({lists: lists, staff: staff});
                self.getTransactions();
            });
        });
    }

    updateDates(event, picker) {
        if (event.type == "apply") {
            this.setState({
                startDate: picker.startDate,
                endDate: picker.endDate
            }, () => {
                this.getTransactions()
            });
        }
    }

    setFilter = (key, value, nameKey, name) => {
        var st = {};
        st[key] = value;
        st[nameKey] = name == null ? "All" : name;
        this.setState(st, () => {
            this.getTransactions()
        });
    }

    getTransactions() {
        this.setState({loading: true});
        var self = this;
        getLedger({
            item_id: self.state.item_id,
            location_id: self.state.location_id,
            doc_type: self.state.doc_type,
            staff_id: self.state.staff_id,
            startDate: self.state.startDate.valueOf(),
            endDate: self.state.endDate.valueOf()
        }, function (rows) {
            self.setState({transactions: rows, loading: false});
        });
    }

    refreshSearch = event => {
        this.getTransactions();
    };

    exportCSV = () => {
        var head = ['Date', 'Form', 'Doc', 'Line', 'Item', 'Location', 'Qty', 'Related', 'Account', 'Comments', 'By'];
        var lines = this.state.transactions.map(t => {
            var loc = t.out_name ? t.out_name + ' → ' + (t.in_name || '') : (t.in_name || '');
            var qty = t.out_inventory_source_id ? -t.quantity : t.quantity;
            return [t.date_eff, DOC_NAMES[t.doc_type] || LEGACY_CODES[t.code] || 'Adjustment', t.doc_no || '', t.line_no || '',
                t.item_code || t.product_name || '', '"' + loc + '"', qty, t.related_doc_no || '', t.account || '',
                '"' + (t.notes || '').replace(/"/g, '""') + '"', (t.staff_first || '') + ' ' + (t.staff_last || '')].join(',');
        });
        var blob = new Blob([head.join(',') + '\n' + lines.join('\n')], {type: 'text/csv'});
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'inventory-transactions.csv';
        a.click();
    }

    render() {
        let start = this.state.startDate.format('MMM. D/YY');
        let end = this.state.endDate.format('MMM. D/YY');
        let label = start + ' - ' + end;
        if (start === end) {
            label = start;
        }
        var self = this;

        return (
            <ContentWrapper>
                <div className="content-heading">
                    <Link to="../inventory">Inventory</Link>&nbsp;/&nbsp;Transactions
                    <div className="ml-auto">
                        <Button size="sm" color="secondary" className="mr-1" onClick={this.exportCSV}>
                            <i className="fas fa-file-csv"></i> CSV
                        </Button>
                        <Button onClick={this.refreshSearch}><i className="fas fa-sync-alt"></i></Button>
                    </div>
                </div>
                <div className="mb-3 form-inline">
                    <DateRangePicker
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        ranges={this.state.ranges}
                        onEvent={this.updateDates}
                        autoUpdateInput={true}
                    >
                        <Button className="selected-date-range-btn mr-1" color="primary">
                            Period: <b>{label}</b> <span className="fas fa-caret-down fa-sm"></span>
                        </Button>
                    </DateRangePicker>
                    <UncontrolledButtonDropdown className="m-1">
                        <DropdownToggle caret color="primary" style={{width: 'auto'}}>
                            Item: <b>{this.state.item_name}</b>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => this.setFilter('item_id', null, 'item_name', null)}>All</DropdownItem>
                            <DropdownItem divider/>
                            {this.state.lists.items.map(i =>
                                <DropdownItem key={i.item_id} onClick={() => this.setFilter('item_id', i.item_id, 'item_name', i.code)}>{i.code}</DropdownItem>)}
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>
                    <UncontrolledButtonDropdown className="m-1">
                        <DropdownToggle color="primary" caret style={{width: 'auto'}}>
                            Location: <b>{this.state.location_name}</b>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => this.setFilter('location_id', null, 'location_name', null)}>All</DropdownItem>
                            <DropdownItem divider/>
                            {this.state.lists.locations.map(l =>
                                <DropdownItem key={l.inventory_source_id} onClick={() => this.setFilter('location_id', l.inventory_source_id, 'location_name', l.name)}>{l.name}</DropdownItem>)}
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>
                    <UncontrolledButtonDropdown className="m-1">
                        <DropdownToggle color="primary" caret style={{width: 'auto'}}>
                            Form: <b>{this.state.doc_type_name}</b>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => this.setFilter('doc_type', null, 'doc_type_name', null)}>All</DropdownItem>
                            <DropdownItem divider/>
                            {Object.keys(DOC_NAMES).filter(k => ['IR', 'TR', 'AJ', 'AB'].indexOf(k) !== -1).map(k =>
                                <DropdownItem key={k} onClick={() => this.setFilter('doc_type', k, 'doc_type_name', DOC_NAMES[k])}>{DOC_NAMES[k]}</DropdownItem>)}
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>
                    <UncontrolledButtonDropdown className="m-1">
                        <DropdownToggle color="primary" caret style={{width: 'auto'}}>
                            By: <b>{this.state.staff_name}</b>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => this.setFilter('staff_id', null, 'staff_name', null)}>All</DropdownItem>
                            <DropdownItem divider/>
                            {Object.keys(this.state.staff).map(function (staff_id) {
                                if (self.state.staff[staff_id].status == 1) {
                                    return (<DropdownItem key={staff_id}
                                        onClick={() => self.setFilter('staff_id', staff_id, 'staff_name',
                                            self.state.staff[staff_id].first_name + ' ' + self.state.staff[staff_id].last_name)}>
                                        {self.state.staff[staff_id].first_name} {self.state.staff[staff_id].last_name}
                                    </DropdownItem>)
                                }
                            })}
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>
                </div>
                <div className={(this.state.loading ? "card card-default whirl traditional" : "card card-default")}>
                    <div className={(this.state.loading ? "invisible" : "")}>
                        <div className="card-header">
                            <div className="card-title">{this.state.transactions.length} Matching Transactions</div>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className={(this.state.transactions.length > 0 && !this.state.loading ? "table table-hover" : "d-none")}>
                                    <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Form</th>
                                        <th>Doc</th>
                                        <th className="d-none d-xl-table-cell">Line</th>
                                        <th>Item</th>
                                        <th>Location</th>
                                        <th className="text-right">Qty</th>
                                        <th className="d-none d-sm-table-cell">Related</th>
                                        <th className="d-none d-sm-table-cell">Account</th>
                                        <th className="d-none d-sm-table-cell">Comments</th>
                                        <th className="d-none d-sm-table-cell">By</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.transactions.map(function (t, key) {
                                        var out = t.out_inventory_source_id != null && t.out_inventory_source_id != 0;
                                        var loc = out ? (t.out_name + (t.in_name ? ' → ' + t.in_name : '')) : t.in_name;
                                        var qty = (out ? '-' : '+') + fmt(t.quantity);
                                        var form = DOC_NAMES[t.doc_type] || LEGACY_CODES[t.code] || 'Adjustment';
                                        var by = t.staff_first ? t.staff_first + ' ' + (t.staff_last || '').charAt(0) + '.' : '';
                                        return (
                                            <tr key={key}>
                                                <td>{t.date_eff}</td>
                                                <td>{form}</td>
                                                <td>{t.doc_no || ('ADJ-' + t.inventory_transfer_id)}</td>
                                                <td className="d-none d-xl-table-cell">{t.line_no || ''}</td>
                                                <td>{t.item_code || t.product_name || '?'}</td>
                                                <td>{loc || '--'}</td>
                                                <td className={(out ? "text-right text-danger" : "text-right text-success")}>{qty}</td>
                                                <td className="d-none d-sm-table-cell">{t.related_doc_no || ''}</td>
                                                <td className="d-none d-sm-table-cell">{t.account || ''}</td>
                                                <td className="d-none d-sm-table-cell">{t.notes || ''}</td>
                                                <td className="d-none d-sm-table-cell">{by}</td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </ContentWrapper>
        );
    }
}

export default (InventoryTransactions);
